import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { radiologyQKeys } from "@hooks/queries/radiology/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreateRadiology = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (radiology: FormData) => {
      return api.post("radiology/", radiology, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      // console.log(res.data)
      showSuccessNotification({
        title: "success",
        message: "create-radiology-success",
      });
      queryClient.invalidateQueries({
        queryKey: radiologyQKeys.patient(variables.get("patient_id") as string),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.get("patient_id") as string),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Radiology]", res);

      handleErrors(res, "mutation");
    },
  });
};
